export const convertBytes = (bytes) => {
    if (bytes < 1024) {
      return bytes + " Bytes";
    }
    
    const units = ["KB", "MB", "GB"];
    let i = -1;
    
    do {
        bytes = bytes / 1024;
        i++;
    } while (bytes >= 1024 && i < units.length - 1);
    
    return `${bytes.toFixed(0)}${units[i]}`;
  }